import { AbstractController } from '@/Emulator/Controller/AbstractController';

const GamepadButton = {
    DPAD_UP:    12,
    DPAD_DOWN:  13,
    DPAD_LEFT:  14,
    DPAD_RIGHT: 15,
    B:          2,
    A:          0,
    SELECT:     8,
    START:      9,
    L1:         4,
    R1:         5,
    L2:         6,
    R2:         7,
    L3:         10,
    R3:         11,
};

export class GamepadController extends AbstractController
{
    private _buttonStates: boolean[] = new Array(32).fill(false);

    constructor(
        public readonly name: string,
        public readonly index: number,
    )
    {
        super();
    }

    public override tick(): void
    {
        const gp = navigator.getGamepads()[this.index];
        if (!gp) {
            return;
        }

        for (let i = 0, l = gp.buttons.length; i < l; i++) {
            if (gp.buttons[i].pressed !== this._buttonStates[i]) {
                this._buttonStates[i]  = gp.buttons[i].pressed;
                const pressed: boolean = this._buttonStates[i];

                console.log(i);

                switch (i) {
                    case GamepadButton.DPAD_UP:
                        this.dispatch('button-up', pressed);
                        break;
                    case GamepadButton.DPAD_DOWN:
                        this.dispatch('button-down', pressed);
                        break;
                    case GamepadButton.DPAD_LEFT:
                        this.dispatch('button-left', pressed);
                        break;
                    case GamepadButton.DPAD_RIGHT:
                        this.dispatch('button-right', pressed);
                        break;
                    case GamepadButton.A:
                        this.dispatch('button-a', pressed);
                        break;
                    case GamepadButton.B:
                        this.dispatch('button-b', pressed);
                        break;
                    case GamepadButton.START:
                        this.dispatch('button-start', pressed);
                        break;
                    case GamepadButton.SELECT:
                        this.dispatch('button-select', pressed);
                        break;
                    case GamepadButton.L1:
                    case GamepadButton.L2:
                    case GamepadButton.L3:
                        this.dispatch('load-state', pressed);
                        break;
                    case GamepadButton.R1:
                    case GamepadButton.R2:
                    case GamepadButton.R3:
                        this.dispatch('save-state', pressed);
                        break;
                }
            }
        }
    }
}
